import React, { HTMLAttributes, useContext } from 'react';
import { CommentContext } from '../../CommentContext';

interface Props extends HTMLAttributes<HTMLDivElement> {}

/**
 * We need these data attributes on a certain level of our comment views, so we have this component to make it easy
 * to include it in multiple places.
 */
const CommentDataAttrDiv: React.FC<Props> = props => {
  const { comment } = useContext(CommentContext);
  return (
    <div
      data-commentid={comment.commentId}
      data-typeid={comment.typeId}
      data-itemid={comment.itemId}
      {...props}
    />
  );
};
CommentDataAttrDiv.displayName = 'CommentDataAttrDiv';

export default CommentDataAttrDiv;
